import { connect } from 'react-redux';
import {
  commonRoomPostsExcludingRecentImportantSelector,
  participantCount,
} from '@core/selectors/classroom';
import { getCurrentSpaceId } from '@core/selectors/space';
import CommonRoomResponsive from './CommonRoomResponsive';

const mapStateToProps = (state) => ({
  participantTotal: participantCount(state),
  spaceId: getCurrentSpaceId(state),
  posts: commonRoomPostsExcludingRecentImportantSelector(state),
});

export default connect(mapStateToProps)(CommonRoomResponsive);
